import VueI18n from 'vue-i18n';
import Vue from 'vue';
import th from './th.json';
import en from './en.json';

Vue.use(VueI18n);

const messages = {
  th,
  en
};

export default new VueI18n({
  locale: 'th',
  messages
});
